import ky from 'ky';
import { DEFAULT_API_OPTIONS } from '../config/ky';

export async function getLibraries() {
  const res = await ky.get('libraries?limit=100', DEFAULT_API_OPTIONS);
  const libraries = await res.json();
  if (!libraries) throw Error('API error');
  return libraries;
}
